angular.module('bmsApp.settings').factory('SMHouseTemplateSvc', function ($rootScope, $http, $log, $window, $q, CRUDSvc, $modal) {
	return {
		index: function (params) {
			return CRUDSvc.get('api/sm/houseTemplate/index', params);
		},
		save: function (params) {
			return CRUDSvc.post('api/sm/houseTemplate/save', params);
		},
		read: function(id) {
			return CRUDSvc.get('api/sm/houseTemplate/read/' + id);
		},
		options: function (data) {
			return CRUDSvc.get('api/sm/houseTemplate/options', data);
		},
		showSelectTemplateModal: function(cleaningService) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/sm/quote/templates/SelectTemplateModal.html',
				controller: 'SMSelectTemplateModalCtrl',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static' // disable click-outside closing modal
			});

			return modalInstance.result;
		}
	}
});




